import * as React from 'react'
import { useData } from './useData'
import Box from '@mui/material/Box'
import { useCallback } from 'react'
import { HighlightedText } from '@sales-center/components'
import Typography from '@mui/material/Typography'

export type Props = {
  highlightColor: string
  locationCode: string
  externalLinkId: string
  externalLinkType: string
  onClick: () => void
  searchText: string
}

export function LocationLink(props: Props) {
  const { highlightColor, locationCode, onClick, searchText } = props

  const { locationUrl } = useData(props)

  const handleClick = useCallback(
    (e) => {
      e.preventDefault()
      e.stopPropagation()
      window.open(locationUrl, '_blank')
      onClick()
    },
    [locationUrl, onClick],
  )

  return (
    <Box>
      <Typography variant="body2" sx={{ display: 'inline', lineHeight: 0 }}>
        <Box component="span">Location{':\u00A0'}</Box>
        <a
          href="#"
          onClick={handleClick}
          target="_blank"
          rel="noreferrer"
          style={{ verticalAlign: 'baseline' }}
        >
          <HighlightedText
            highlightColor={highlightColor}
            text={locationCode}
            searchText={searchText}
          />
          <img
            src="/static-assets/icons/arrow-northeast-outlined.svg"
            style={{ position: 'relative', bottom: '2px', left: '4px' }}
          />
        </a>
      </Typography>
    </Box>
  )
}
